<div class="container container-border container-size">
  <div class="row">
    <div class="col-md-12">
      <div class="row-zweispaltig">
        <div class="column-zweispaltig-gross">
          <h4>
            Informationen zur Datenverarbeitung in der Web-Anwendung
            "{{ anwendungsname }}"
          </h4>
        </div>
        <div class="column-zweispaltig-klein img-container-zentriert">
          <img
            src="assets/img/Logo_KTBL.png"
            alt="Logo-KTBL"
            class="img"
            height="78.23px"
            style="float: right"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="spacer"></div>
  <mat-card>
    <mat-dialog-content>
      <h5><b> ... bei Direkteingabe in das Formular</b></h5>

      Die Daten werden verarbeitet und sofort danach wieder auf dem KTBL-Server
      gelöscht.
      <p></p>
      Eine Auswertung seitens KTBL findet nicht statt.

      <p></p>
      <h5><b> ... beim Einlesen von CSV-Buchführungsabschlüssen</b></h5>
      Die Daten werden verarbeitet und sofort danach wieder auf dem KTBL-Server
      gelöscht.
      <p></p>
      Eine Auswertung seitens KTBL findet nicht statt.
      <p></p>
      Es werden nur die für die Berechnung des Standardoutputs benötigten
      BMEL-Codes eingelesen.
      <p></p>
      Eine Auflistung der übertragenen und verarbeiteten Codes finden Sie

      <a routerLink="/pseudonymisierung-code"  [mat-dialog-close]="false">hier</a>.

      <p></p>
      Die Betriebsnummer wird vor dem Übertrag auf den KTBL-Server
      pseudonymisiert und so weiterverarbeitet. Eine Übersetzung in die
      originale Betriebsnummer erfolgt nach dem Übertrag der Ergebnisse auf
      ihren Rechner.
      <p></p>
      Das Verfahren der Pseudonymisierung ist
      <a routerLink="/pseudonymisierung-verfahren"  [mat-dialog-close]="false">hier</a> in
      Einzelschritten beschrieben.

      <div class="spacer"></div>
      <mat-card>
        <div class="row">
          <div class="col-md-12">
            <div class="row-zweispaltig">
              <div class="column-zweispaltig-mittel-gross text-container-zentriert">
                Ich habe die Informationen gelesen, verstanden und bin mit
                dieser Vorgehensweise einverstanden.
              </div>
              <div class="column-zweispaltig-mittel-klein">
                <button
                  mat-raised-button
                  color="warn"
                  class="custom-btn button-margin buttons-right button-width"
                  [mat-dialog-close]="false"
                  tabindex="-1"
                >
                  Nicht einverstanden
                </button>

                <button
                  mat-raised-button
                  color="primary"
                  class="custom-btn button-margin buttons-right button-width"
                  [mat-dialog-close]="true"
                  tabindex="-1"
                >
                  Einverstanden
                </button>
              </div>
            </div>
          </div>
        </div>
      </mat-card>
      <div class="spacer"></div>
    </mat-dialog-content>
  </mat-card>
</div>
<!-- ToDo  Den Block um die Buttens rausnehmen-->
